import React, { useEffect, useState, useMemo } from 'react';
import Sidebar from '../../components/Sidebar';
import '../CompanyHistory.css';

const CompanyOverview = () => {
  const [activeSection, setActiveSection] = useState('company-overview');
  
  const sidebarItems = useMemo(() => [
    { name: 'Company Overview', path: 'company-overview' },
    { name: 'Company History', path: 'company-history' },
    { name: 'Organization', path: 'organization' },
    { name: 'Location', path: 'company-location' }
  ], []);

  // 스크롤 스파이 기능
  useEffect(() => {
    const handleScroll = () => {
      const sections = sidebarItems.map(item => item.path);
      
      for (let i = sections.length - 1; i >= 0; i--) {
        const section = document.getElementById(sections[i]);
        if (section && section.offsetTop - 200 <= window.scrollY) {
          setActiveSection(sections[i]);
          break;
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [sidebarItems]);

  // 해시 URL 처리 (페이지 로드 시 해당 섹션으로 이동)
  useEffect(() => {
    const hash = window.location.hash.replace('#', '');
    if (hash) {
      setActiveSection(hash);
      setTimeout(() => {
        scrollToSection(hash);
      }, 50);
    }
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'auto' });
    }
  };

  const contactInfo = [
    { icon: '👤', label: 'CEO', value: 'Lee Mi Young' },
    { icon: '🏢', label: 'Head Office', value: '327 Namdongdong-ro, Namdong-gu, Incheon (Namdong Industrial Complex 43B 9L)' },
    { icon: '📞', label: 'Head Office Phone', value: '032-811-0511' },
    { icon: '📠', label: 'Head Office Fax', value: '032-819-0518' },
    { icon: '🏢', label: 'Busan Office', value: 'Room 609, 48 Centumjungang-ro, Haeundae-gu, Busan' },
    { icon: '📞', label: 'Busan Phone', value: '051-503-5431' },
    { icon: '📠', label: 'Busan Fax', value: '051-504-1364' },
    { icon: '📧', label: 'Main Email', value: 'saledept@taibong.com' }
  ];

  const mainProducts = [
    'District Heating Compact Equipment Unit',
    'Plate Heat Exchanger',
    'Plate Coil Heat Exchanger',
    'Air Preheater',
    'Expansion Water Separator',
    'Instant Hot Water Heater',
    'Plate Brazing Heat Exchanger',
    'Plate Spiral Heat Exchanger',
    'Closed Expansion Tank',
    'Steel Ball Valve'
  ];

  const historyData = {
    "2020's": [
      { year: "March 2025", event: "ISO9001/ISO14001/ISO45001 Certification Renewal" },
      { year: "February 2022", event: "(Co.) Ensol Pohang Factory Operation" },
      { year: "February 2021", event: "Potable Water Sanitary Safety Standards (KC) Certification Acquisition" }
    ],
    "2010's": [
      { year: "April 2017", event: "Strong Small Business Certification Acquisition" },
      { year: "July 2016", event: "ISO 14001 Certification Acquisition" },
      { year: "October 2016", event: "ASME Certification Acquisition" },
      { year: "July 2015", event: "Plate Heat Exchanger Full Plate Gasket Patent Acquisition" },
      { year: "December 2012", event: "Vision Enterprise Certification" },
      { year: "May 2011", event: "New & Renewable Energy Equipment Installation Specialist Registration" },
      { year: "June 2011", event: "Ensol Subsidiary Establishment" },
      { year: "August 2011", event: "Energy Saving Specialist Enterprise Registration (ESCO)" }
    ],
    "2000's": [
      { year: "March 2007", event: "Korea District Heating Corporation National User Education Implementation" },
      { year: "January 2006", event: "Plate Heat Exchanger Double Layer Structure Patent Acquisition" },
      { year: "March 2006", event: "Waste Heat Recovery System, Bath Water Filter Device Patent Acquisition" },
      { year: "May 2005", event: "China Shenyang Taiwujiden Factory Expansion Relocation" },
      { year: "November 2005", event: "Korea Hydro & Nuclear Power Supplier Selection" },
      { year: "March 2004", event: "KEPIC (Korea Electric Power Industry Code) Q Class Certification Acquisition" },
      { year: "May 2004", event: "China Nanjing, Beijing Taiwujiden Office Establishment" },
      { year: "October 2003", event: "40,000-ton Plate Forming Press Completion" },
      { year: "June 2002", event: "Promising Small Business Selection (Incheon Metropolitan City)" },
      { year: "July 2002", event: "Japan Agent Office Establishment" },
      { year: "August 2002", event: "China Shenyang Joint Venture Taiwujiden Factory Completion, Singapore Agent Office Establishment" },
      { year: "May 2001", event: "Export Promising Small Business Selection (SME Administration)" },
      { year: "December 2000", event: "ISO-9001-2000, DNV Certification Acquisition, Taiwan Agent Office Establishment" }
    ],
    "1990's": [
      { year: "January 1999", event: "Plate Heat Exchanger Easy-Hook Gasket Structure Development, Advanced 5 Countries Patent Acquisition" },
      { year: "October 1996", event: "Incheon Namdong Industrial Complex Expansion Relocation, Fin Tube Wrapping Machine Introduction from US McElroy" },
      { year: "February 1993", event: "Spiral Heat Exchanger Production Line Operation" }
    ],
    "1980's": [
      { year: "February 1989", event: "Bucheon Factory Relocation" },
      { year: "May 1989", event: "Norway Classification Society (DNV) Ship Lub Oil Cooler Type Approval, 20,000-ton Plate Forming Press Installation" },
      { year: "December 1986", event: "Plate Coil First Domestic Development" },
      { year: "May 1985", event: "Heat Exchanger Design Computer Program Development" },
      { year: "July 1983", event: "Plate Heat Exchanger (Herringbone Type) First Domestic Success" },
      { year: "June 1982", event: "Taebong Industries Establishment" }
    ]
  };

  // 스크롤 스파이 기능
  useEffect(() => {
    const handleScroll = () => {
      const sections = ['company-overview', 'company-history', 'company-location', 'organization'];
      const scrollPosition = window.scrollY + 200;

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const { offsetTop, offsetHeight } = element;
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <Sidebar 
        category="Company Overview" 
        items={sidebarItems} 
        activeSection={activeSection}
        onItemClick={scrollToSection}
      />
      <div className="company-history-page">
        <div className="history-container">
          <h1 className="page-category-title">Company Overview</h1>
          {/* Company Overview Section */}
          <section id="company-overview" className="section">
            <h2 className="section-title">Company Overview</h2>
            
            <div className="section-container">
              <div className="company-intro-section">
              <div className="company-slogan">
                <h3>40 Years of Trust, Beyond Value</h3>
              </div>
              <p className="intro-text">
                Starting with the first domestic development of plate heat exchangers, we are a specialized heat exchanger manufacturer with 40 years of experience, providing various heat exchange solutions for heating and cooling processes across industries and building HVAC systems, covering liquid-liquid, liquid-gas, and gas-gas exchanges.
              </p>
              
              <div className="company-details">
                <div className="detail-row">
                  <span className="detail-label">CEO:</span>
                  <span className="detail-value">Lee Mi Young</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Established:</span>
                  <span className="detail-value">June 10, 1982</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Production Facility Scale:</span>
                  <span className="detail-value">Incheon Plant 1 (8,473m²), Pohang Plant 2 (32,000m²)</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Main Products:</span>
                  <span className="detail-value">Plate Heat Exchangers, District Heating Compact Units and Other Auxiliary Equipment</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Head Office Address:</span>
                  <span className="detail-value">327 Namdongdong-ro, Namdong-gu, Incheon (Namdong Industrial Complex 43B 9L)</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Head Office Phone:</span>
                  <span className="detail-value">032-811-0511</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Head Office Fax:</span>
                  <span className="detail-value">032-819-0518</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Main Email:</span>
                  <span className="detail-value">saledept@taibong.com</span>
                </div>
              </div>
              </div>
            </div>
          </section>

          {/* Company History Section */}
          <section id="company-history" className="section">
            <h2 className="section-title">Company History</h2>
            <div className="section-container">
              <div className="history-timeline">
              {Object.entries(historyData).map(([decade, events]) => (
                <div key={decade} className="timeline-decade">
                  <div className="decade-marker">
                    <span className="decade-text">{decade}</span>
                  </div>
                  <div className="decade-events">
                    {events.map((item, index) => (
                      <div key={index} className="event-item">
                        <span className="event-year">{item.year}</span>
                        <span className="event-description">{item.event}</span>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
              </div>
            </div>
          </section>

          {/* Organization Chart Section */}
          <section id="organization" className="section">
            <h2 className="section-title">Organization Chart</h2>
            <div className="section-container">
              <div className="organization-chart">
                <img src="/jojic.png" alt="Taebong Industrial Technology Organization Chart" />
              </div>
            </div>
          </section>

          {/* Location Section */}
          <section id="company-location" className="section">
            <h2 className="section-title">Location</h2>
            <div className="section-container">
              <div style={{ textAlign: 'center' }}>
              <p style={{ fontSize: '1.1rem', color: '#666' }}>
                Directions to Taebong Industrial Technology.
              </p>
              <div style={{ marginTop: '2rem', padding: '2rem', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                <h3 style={{ marginBottom: '1rem' }}>Head Office & Factory</h3>
                <p><strong>Address:</strong> 327 Namdong-ro, Namdong-gu, Incheon (Namdong Industrial Complex 43B-9L)</p>
                <div className="desktop-only-map" style={{ marginTop: '1rem', display: 'flex', justifyContent: 'center' }}>
                  <img src="/map1.png" alt="Head Office & Factory Location" style={{ width: '60%', height: '350px', objectFit: 'cover', borderRadius: '8px' }} />
                </div>
              </div>
              <div style={{ marginTop: '2rem', padding: '2rem', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                <h3 style={{ marginBottom: '1rem' }}>Southern Office</h3>
                <p><strong>Address:</strong> 968 Haenghae-eup, Buk-gu, Pohang-si, Gyeongsangbuk-do</p>
                <div className="desktop-only-map" style={{ marginTop: '1rem', display: 'flex', justifyContent: 'center' }}>
                  <img src="/map2.png" alt="Southern Office Location" style={{ width: '60%', height: '350px', objectFit: 'cover', borderRadius: '8px' }} />
                </div>
              </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default CompanyOverview;
